import {
  type DependencyList,
  type EffectCallback,
  useCallback,
  useEffect,
  useRef,
} from "react";

export const useDebouncedEffect = (
  effect: EffectCallback,
  wait: number,
  deps?: DependencyList
) => {
  const initialRender = useRef(true);
  const callback = useCallback(effect, deps || []);

  useEffect(() => {
    // Skip effect on initial render.
    if (initialRender.current) {
      return void (initialRender.current = false);
    }

    const handler = setTimeout(() => {
      callback();
    }, wait);

    return () => clearTimeout(handler);
  }, [callback, wait, ...(deps || [])]);
};
